
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component<BasePillButton>({})
export default class BasePillButton extends Vue {
    @Prop({
        type: Boolean,
        required: false,
        default: false,
    })
    readonly isActive!: boolean

    @Prop({
        type: Boolean,
        required: false,
        default: false,
    })
    readonly disabled!: boolean

    onClick() {
        if (this.disabled) {
            return
        }
        this.$emit('click')
    }
}
